import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin } from "lucide-react";
import { NAV_LINKS, SERVICE_AREAS, CONTACT_EMAIL, CONTACT_PHONE } from "@/lib/site";
import { PaperPlane } from "@/components/PaperPlane";

export const Footer = () => (
  <footer className="relative z-10 border-t border-white/10 bg-ink-900" data-testid="footer">
    <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-16">
      <div className="grid md:grid-cols-12 gap-12">
        <div className="md:col-span-4">
          <Link to="/" className="font-display text-2xl inline-flex items-center gap-2">
            <PaperPlane className="w-5 h-5 -rotate-12" />
            <span className="font-black text-white">Prolific</span>
            <span className="font-light text-cream/90">Maven</span>
          </Link>
          <p className="mt-4 text-gold text-sm tracking-[0.2em] uppercase">Clarify. Refine. Amplify.</p>
          <p className="mt-3 text-cream/50 text-sm max-w-xs">Your voice is your edge. We help you steward it.</p>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs uppercase tracking-widest text-cream/40 mb-4">Navigate</h4>
          <ul className="space-y-2">
            <li><Link to="/" className="text-cream/70 hover:text-gold text-sm transition-colors">Home</Link></li>
            {NAV_LINKS.map((l) => (
              <li key={l.to}><Link to={l.to} className="text-cream/70 hover:text-gold text-sm transition-colors">{l.label}</Link></li>
            ))}
            <li><Link to="/contact" className="text-cream/70 hover:text-gold text-sm transition-colors">Contact</Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-widest text-cream/40 mb-4">Service Area</h4>
          <p className="text-cream/60 text-sm leading-relaxed">{SERVICE_AREAS.join(" · ")}</p>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs uppercase tracking-widest text-cream/40 mb-4">Get in touch</h4>
          <a href={`mailto:${CONTACT_EMAIL}`} className="block text-cream/70 hover:text-gold text-sm transition-colors" data-testid="footer-email">{CONTACT_EMAIL}</a>
          <a href="tel:+18137203565" className="block mt-1 text-cream/70 hover:text-gold text-sm transition-colors" data-testid="footer-phone">{CONTACT_PHONE}</a>
          <div className="flex gap-4 mt-5">
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="text-cream/60 hover:text-gold transition-colors"><Facebook size={20} /></a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-cream/60 hover:text-gold transition-colors"><Instagram size={20} /></a>
            <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-cream/60 hover:text-gold transition-colors"><Linkedin size={20} /></a>
          </div>
        </div>
      </div>

      <div className="mt-14 pt-8 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-4">
        <p className="text-cream/40 text-xs">© 2025 Prolific Maven. All rights reserved.</p>
        <p className="text-cream/40 text-xs max-w-md sm:text-right">Serving local businesses across Manatee, Hillsborough, Sarasota, and Pinellas Counties in Florida.</p>
      </div>
    </div>
  </footer>
);

export default Footer;
